import { define } from 'wicked-elements'
import onIntersect from '../lib/on-intersect.js'

define('[data-component~="sticky"]', {
  init () {
    this.$target = this.element.nextElementSibling
    this.onIntersect = this.onIntersect.bind(this)
  },
  connected () {
    this.stopObserving = onIntersect(this.element, {
      threshold: [0, 1]
    }, this.onIntersect, this.onIntersect)
  },
  disconnected () {
    this.stopObserving()
  },
  onIntersect (e) {
    if (e.intersectionRatio === 0) {
      this.$target.classList.add('stuck')
    } else {
      this.$target.classList.remove('stuck')
    }
  }
})